import React, { type FC } from 'react'
import { Button, MenuItem, Select } from '@mui/material'
import { FormikProps } from 'formik'
import Colors from '../../../utils/colors'
import InputTextField from '../../../components/InputTextField'
import { FormValues } from './OtpForm'

interface AdditionalInfoFormProps {
  additionalInfo?: any
  formik: FormikProps<FormValues>
  t: (key: string) => string
  setIsStateRequired: (value: boolean) => void
}

const AdditionalInfoForm: FC<AdditionalInfoFormProps> = ({
  additionalInfo,
  formik,
  t,
  setIsStateRequired,
}) => {
  function getFilteredAdditionalInfo(item: any) {
    const parentField = additionalInfo?.find((i: any) => i.name === item.parentFieldName)
    const parentFieldValue = parentField?.enumeratedValues?.find(
      (i: any) => i.itemValue === formik.values[item.parentFieldName],
    )
    const filteredItems = item?.enumeratedValues?.filter(
      (i: any) => i.parentItemValue === parentFieldValue?.itemValue,
    )
    if (!filteredItems?.length) {
      setIsStateRequired(false)
    }
    if (filteredItems?.length) {
      setIsStateRequired(true)
    }
    if (!filteredItems?.length && formik.values[item.name] !== null) {
      formik.setFieldValue(item.name, null)
    }

    return filteredItems
  }

  const generateFields = (item: any) => {
    if (item.isEnumerated && !item.parentFieldName) {
      return (
        <div className='w-full items-center flex flex-col'>
          <div className='font-nexaBold text-[16px] text-start'>{item?.caption}</div>
          <Select
            className='sm:w-6/12 w-full bg-white my-[10px]'
            labelId={item?.name}
            id={item?.name}
            placeholder={item?.caption}
            value={item.name in formik.values && formik?.values[item?.name]}
            sx={{
              '&.MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: formik.errors[item.name] && 'red',
                },
                '&:hover fieldset': {
                  borderColor: formik.errors[item.name] ? 'red' : Colors.primary.secondary,
                },
                '&.Mui-focused fieldset': {
                  borderColor: formik.errors[item.name] ? 'red' : Colors.primary.secondary,
                },
              },
            }}
            color='secondary'
            onChange={(e) => {
              formik.setFieldValue(item?.name, e.target.value)
            }}
          >
            {item?.enumeratedValues?.map((provider: any) => (
              <MenuItem
                value={provider.itemValue}
                key={`provider:${provider?.itemValue}:${provider?.itemCaption}`}
              >
                {provider.itemCaption}
              </MenuItem>
            ))}
          </Select>
        </div>
      )
    }
    if (item.isEnumerated && item.parentFieldName && formik.values[item.parentFieldName] !== null) {
      const filteredItems = getFilteredAdditionalInfo(item)
      if (!filteredItems?.length) {
        // formik.setFieldValue(item.name, null)
        return null
      }
      return (
        <div className='w-full items-center flex flex-col'>
          <div className='font-nexaBold text-[16px] text-start'>{item?.caption}</div>
          <Select
            className='sm:w-6/12 w-full bg-white my-[10px]'
            labelId={item?.name}
            id={item?.name}
            placeholder={item?.caption}
            value={item.name in formik.values && formik?.values[item?.name]}
            sx={{
              '&.MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: formik.errors[item.name] && 'red',
                },
                '&:hover fieldset': {
                  borderColor: formik.errors[item.name] ? 'red' : Colors.primary.secondary,
                },
                '&.Mui-focused fieldset': {
                  borderColor: formik.errors[item.name] ? 'red' : Colors.primary.secondary,
                },
              },
            }}
            color='secondary'
            onChange={(e) => {
              formik.setFieldValue(item?.name, e.target.value)
            }}
          >
            {filteredItems.map((provider: any) => (
              <MenuItem
                value={provider.itemValue}
                key={`provider:${provider?.itemValue}:${provider?.itemCaption}`}
              >
                {provider.itemCaption}
              </MenuItem>
            ))}
          </Select>
        </div>
      )
    }
    if (item.isEnumerated && item.parentFieldName && formik.values[item.parentFieldName] === null) {
      return null
    }
    return (
      <div className='sm:w-6/12 w-full flex-col'>
        <div className='font-nexaBold text-[16px] text-center'>{item?.caption}</div>
        <InputTextField
          label={item.caption}
          formik={formik}
          name={item?.name}
          className='bg-white '
          onBlur={(e) => {
            formik.handleBlur(e)
          }}
          value={item.name in formik.values && formik?.values[item?.name]}
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          error={formik.touched[item.name] && formik.errors[item.name]}
          onChange={(e) => {
            const { value } = e.target
            if (item.regex) {
              const re = new RegExp(item.regex)
              if (re.test(value)) {
                formik.setFieldValue(item.name, value)
              }
            } else {
              formik.setFieldValue(item.name, value)
            }
          }}
        />
      </div>
    )
  }

  return (
    <form
      className='w-full h-full flex-1 container bg-infoBackground flex flex-col items-center justify-between min-h-[50vh] p-8'
      onSubmit={formik.handleSubmit}
    >
      <div className='h-full flex flex-col items-center justify-center sm:pb-[32px] pb-4 sm:w-10/12 w-full'>
        <div className='font-nexaBold text-[36px] text-center'>{t('t2c-page.otp.title')}</div>
      </div>
      {additionalInfo &&
        additionalInfo?.map((item: any) => (
          <div
            className='w-full flex flex-col items-center justify-center'
            key={`aditionalInfo:${item?.name}:${item?.caption}`}
          >
            {generateFields(item)}
          </div>
        ))}
      <Button
        type='submit'
        className='sm:w-6/12 w-full mt-[32px]'
        variant='contained'
        color='primary'
      >
        {t('p2p-page.otp.button')}
      </Button>
    </form>
  )
}

export default AdditionalInfoForm
